// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2M6OJ","tab":"ProcedureTabs_tab__2bvx-"};